import { OrderParty, NonCdsOrderResource } from "../api/nonCdsOrders/get";
import { CreateNonCdsOrderResponse, CreateNonCdsOrderRequest } from "../api/nonCdsOrders/create";
import { UpdateNonCdsOrderRequest } from "../api/nonCdsOrders/update";
import { NonCdsOrderCommodityResource } from "../api/nonCdsOrders/getCommodities";
import { AddNonCdsOrderCommodityRequest } from "../api/nonCdsOrders/addCommodity";
import { UpdateNonCdsOrderCommodityRequest } from "../api/nonCdsOrders/updateCommodity";

export class EditNonCdsOrderViewModel {
  id: number | null = null;
  crn: string;
  deliveryInstructions: string;
  facility: string;
  consigneeName: string;
  consigneeAddressLine1: string;
  consigneeAddressLine2: string;
  consigneeAddressCity: string;
  consigneeAddressState: string;
  consigneeAddressZip: string;
  consigneePrimaryPhone: string;
  consigneeSecondaryPhone: string;
  commodities: NonCdsOrderCommodityViewModel[] = [];
  loading: boolean;
  modalIsVisible: boolean = false;
  saving: boolean = false;

  constructor() {
    this.loading = true;
  }

  get isNew() {
    return this.id === null;
  }

  async displayExistingOrder(
    order: NonCdsOrderResource,
    commodities: NonCdsOrderCommodityResource[]
  ) {
    this.id = order.id;
    this.crn = order.customerReferenceNumber;
    this.deliveryInstructions = order.deliveryInstructions;
    this.facility = order.facilityCode;
    this.consigneeName = order.consignee ? order.consignee.name : null;
    this.consigneeAddressLine1 =
      order.consignee && order.consignee.address ? order.consignee.address.streetLine1 : null;
    this.consigneeAddressLine2 =
      order.consignee && order.consignee.address ? order.consignee.address.streetLine2 : null;
    this.consigneeAddressCity =
      order.consignee && order.consignee.address ? order.consignee.address.city : null;
    this.consigneeAddressState =
      order.consignee && order.consignee.address ? order.consignee.address.state : null;
    this.consigneeAddressZip =
      order.consignee && order.consignee.address ? order.consignee.address.zip : null;
    this.consigneePrimaryPhone = order.consignee ? order.consignee.primaryPhone : null;
    this.consigneeSecondaryPhone = order.consignee ? order.consignee.secondaryPhone : null;
    this.loading = false;

    this.commodities = [];
    commodities.forEach(commodity => {
      this.commodities.push(new NonCdsOrderCommodityViewModel(commodity));
    });
  }

  displayNewOrder() {
    this.loading = false;
  }

  toConsigneeOrderParty(): OrderParty {
    return {
      name: this.consigneeName,
      address: {
        streetLine1: this.consigneeAddressLine1,
        streetLine2: this.consigneeAddressLine2,
        state: this.consigneeAddressState,
        city: this.consigneeAddressCity,
        zip: this.consigneeAddressZip
      },
      primaryPhone: this.consigneePrimaryPhone,
      secondaryPhone: this.consigneeSecondaryPhone
    };
  }

  toCreateRequest(): CreateNonCdsOrderRequest {
    return {
      facilityCode: this.facility,
      customerReferenceNumber: this.crn,
      consignee: this.toConsigneeOrderParty(),
      deliveryInstructions: this.deliveryInstructions
    };
  }

  toUpdateRequest(): UpdateNonCdsOrderRequest {
    return {
      facilityCode: this.facility,
      customerReferenceNumber: this.crn,
      consignee: this.toConsigneeOrderParty(),
      deliveryInstructions: this.deliveryInstructions,
      id: this.id
    };
  }

  get shouldRenderAddCommodityLink() {
    return this.commodities && this.commodities.filter(x => !x.isSaved).length === 0;
  }

  addEmptyCommodity() {
    this.commodities.push(new NonCdsOrderCommodityViewModel());
  }
}

export class NonCdsOrderCommodityViewModel {
  id: number = null;
  commodityCode: string;
  description: string;
  quantity: number;
  volume: number;
  weight: number;
  orderId: number;

  constructor(commodity: NonCdsOrderCommodityResource = null) {
    if (commodity) {
      this.id = commodity.id;
      this.commodityCode = commodity.commodityCode;
      this.description = commodity.description;
      this.quantity = commodity.quantity;
      this.volume = commodity.volume;
      this.weight = commodity.weight;
      this.orderId = commodity.nonCDSOrderId;
    }
  }

  get isNew() {
    return this.id === null;
  }

  get isSaved() {
    return this.id !== null;
  }

  toCreateRequest(): AddNonCdsOrderCommodityRequest {
    return {
      commodityCode: this.commodityCode,
      description: this.description,
      quantity: +this.quantity,
      volume: +this.volume,
      weight: +this.weight,
      nonCDSOrderId: this.orderId
    };
  }
  toUpdateRequest(): UpdateNonCdsOrderCommodityRequest {
    return {
      commodityCode: this.commodityCode,
      description: this.description,
      quantity: +this.quantity,
      volume: +this.volume,
      weight: +this.weight,
      nonCDSOrderId: this.orderId,
      id: this.id
    };
  }
}
